import { SlideIn } from '@salecycle/ui-component-library';
import { ReactNode, PropsWithChildren, CSSProperties, useEffect, useState } from 'react';
import styled from 'styled-components';
import { DrawerHeader, DrawerHeaderProps } from './DrawerHeader';
import { DrawerOverlay } from './DrawerOverlay';

const StyledDrawer = styled.div`
  background-color: ${({ theme }) => theme.vars.newColor.white};
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const DrawerBody = styled.div`
  padding: 32px 40px 0 40px;
  overflow-y: auto;
  height: 100%;
  flex-grow: 1;
  width: 100%;
`;

const DrawerFooter = styled.div`
  padding: 12px 40px;
  width: 100%;
  display: flex;
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  align-items: flex-end;
`;

interface StylableComponent {
  style?: CSSProperties;
}

type Direction = 'left' | 'right';

export interface DrawerProps extends DrawerHeaderProps, StylableComponent {
  header?: ReactNode;
  open?: boolean;
  footer?: ReactNode;
  direction?: Direction;
  fullScreen?: boolean;
}

let openDrawers = 0;
export function Drawer({
  header,
  footer,
  onClose,
  open,
  style,
  children,
  fullScreen,
  direction = 'left',
}: PropsWithChildren<DrawerProps>) {
  const [zIndex, setZIndex] = useState(0);
  useEffect(() => {
    if (open) {
      openDrawers++;
    } else if (openDrawers !== 0) {
      openDrawers--;
    }

    setZIndex(openDrawers);
  }, [open]);

  return (
    <>
      {fullScreen && <DrawerOverlay onClick={onClose} open={open} />}
      <SlideIn
        isOpen={open}
        direction={direction}
        style={{
          ...style,
          ...{
            zIndex: 10 + zIndex,
            position: fullScreen ? 'fixed' : 'absolute',
            top: 0,
            [direction]: 0,
            width: '800px',
            maxWidth: '90%',
          },
        }}
      >
        <StyledDrawer>
          <FlexContainer>
            {header && <DrawerHeader onClose={onClose}>{header}</DrawerHeader>}
            <DrawerBody>{children}</DrawerBody>
            {footer && <DrawerFooter>{footer}</DrawerFooter>}
          </FlexContainer>
        </StyledDrawer>
      </SlideIn>
    </>
  );
}
